import {BaseHashParamsModel} from "../../../core/components/router/models/base-hash-params-model";

export class AllScoresHashParamsModel extends BaseHashParamsModel {
  id: Number;

  constructor(params) {
    super(params);

    this.date = params?.date || null;
  }
}
